export default {
    registerMapEventsHandlers: (map, eventHandler) => {
        map.on('moveend', eventHandler);
        map.on('zoomend', eventHandler);
    },

    deregisterMapEventsHandlers: (map, eventHandler) => {
        map.off('moveend', eventHandler);
        map.off('zoomend', eventHandler);
    }
};



// WEBPACK FOOTER //
// ./map/tier/trafficIncidentCommons.js